import React from 'react'
import PropTypes from 'prop-types'
import { LogicGateSVG } from './LogicGateSymbol.style'

const ANDLogicGate = (props) => (
  <LogicGateSVG width={40} height={32} viewBox="0 0 34 26" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#687585"
        d="M19.5 0C26.956 0 33 5.82 33 13c0 7.079-5.875 12.836-13.186 12.997L19.5 26H6v-6H0v-2h6V8H0V6h6V0h13.5z"
        className="selection"
      />
      <text
        fill="#FFF"
        fontFamily="Arial-BoldMT, Arial"
        fontSize={9}
        fontWeight="bold"
      >
        <tspan x={9.251} y={16}>
          {'AND'}
        </tspan>
      </text>
    </g>
  </LogicGateSVG>
)

export default ANDLogicGate

ANDLogicGate.propTypes = {
  selected: PropTypes.bool,
}
